import React, { useState, useEffect, useRef } from 'react'
import ActionsRow from './actions-row'
import PlayerRow from '../players/player-row'
import PlayersPagination from '../players/players-pagination'
import PlayerModal from '../player-modal'
import SortingForm from './sorting-form'
import FilterForm from './filters/filter-form'
import Views from '../players/views/index'
import Modal from 'react-bootstrap-modal'
import FlashAlert from '../flash-alert'
import { formatPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input'

const Players = props => {
  const [showPlayer, setShowPlayer] = useState(null)
  const [sortOrder, setSortOrder] = useState('asc')
  const [sorting, setSorting] = useState([])
  const [filters, setFilters] = useState([])
  const [filtersToApi, setFiltersToApi] = useState([])
  const [showSorting, setShowSorting] = useState(false)
  const slowFilters = ['times_played','facility']
  const [sortingsToExclude, setSortingsToExclude] = useState(slowFilters)
  const [showFiltering, setShowFiltering] = useState(false)
  const [showViews, setShowViews] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [showAll, setShowAll] = useState(true)
  const [showTimesPlayed, setShowTimesPlayed] = useState(false)
  const perPage = 50
  const perPreview = 26
  const alert = props.alert
  const timer = useRef()

  useEffect(() => {
    props.loadPlayers()
  }, [])

  useEffect(() => {
    if (sortingsToExclude.includes('times_played')) setShowTimesPlayed(false)
    else if (props.players.length == 0 || props.players[0].times_played) setShowTimesPlayed(true)
  }, [props.players])

  const handleSearch = (value) => {
    setSearchValue(value)
    if (value.length > 0) {
      var newFilters = {type: 'and', group: true, items: [
        {type: 'or', group: false, column: 'name', condition: 'contains', value: value,},
        {type: 'or', group: false, column: 'phone', condition: 'contains', value: value}]}

      var updatedFilters = [...filters]
      updatedFilters.push(newFilters)

      var result = {type: 'or', items: []}
      processFilters(updatedFilters, result.items, 'or')
      props.onConditions({sorting: sorting, conditions: result, perPage: props.perPage || perPage,
        total_entries: showAll ? null : perPreview})
    } else props.onConditions({sorting: sorting, conditions: filtersToApi, perPage: props.perPage || perPage,
        total_entries: showAll ? null : perPreview})
  }

  const setShowViewsOn = () => {
    props.loadViews()
    setShowViews(true)
  }

  const onSetShowAll = () => {
    setShowAll(true)
    props.onConditions({sorting: sorting, conditions: filtersToApi, perPage: props.perPage || perPage})
  }

  const onPageChange = (page) => {
    props.onConditions({sorting: sorting, conditions: filtersToApi, page: page, perPage: props.perPage || perPage})
  }

  const onPerPageChange = (value) => {
    props.onConditions({sorting: sorting, conditions: filtersToApi, perPage: value})
  }

  const formattedPhone = (player) => {
    const intlPhone = player.country_code && player.country_code.toLowerCase() != 'us'
    const result = intlPhone ? formatPhoneNumberIntl(player.phone) : formatPhoneNumber(player.phone)

    return intlPhone ? result.replaceAll(' ', '-') : result
  }

  const copyPhonesToClipboard = (separator) => {
    navigator.clipboard.writeText(props.players.map(el=>formattedPhone(el)).join(separator))
  }

  const handleModalClose = () => {
    setShowPlayer(null)
  }

  const onUpdate = (player) => {
    props.onPlayerUpdate(player)
    setShowPlayer(null)
  }

  const onDelete = (player) => {
    props.onPlayerDelete(player)
    setShowPlayer(null)
  }

  const onSort = (field) => {
    props.clearCurrentView()
    setShowSorting(false)
    var newSortOrder = sortOrder == 'asc' ? 'desc' : 'asc'
    setSortOrder(newSortOrder)

    var newSorting = [{column: field, direction: newSortOrder}]

    setSorting(newSorting)
    props.onConditions({sorting: newSorting, conditions: filtersToApi, perPage: props.perPage || perPage,
      total_entries: showAll ? null : perPreview})
  }

  const onSortList = (sortList) => {
    props.clearCurrentView()
    setShowSorting(false)
    if (sortList.length > 0) {
      props.onConditions({sorting: sortList, conditions: filtersToApi, perPage: props.perPage || perPage,
        total_entries: showAll ? null : perPreview})
      setSorting(sortList)
    } else setSorting([])
  }

  const prepareFilters = (filtersList) => {
    const clearedFiltersList = clearUncompleted(filtersList)
    if (clearedFiltersList.length != 0) {
      var result = {type: 'or', items: []}
      processFilters(clearedFiltersList, result.items, 'or')
      return result
    }
    return false
  }

  const onFilter = (filtersList) => {
    props.clearCurrentView()
    setSearchValue('')
    setShowFiltering(false)
    setFilters(filtersList)

    const result = prepareFilters(filtersList)
    var currentSorting = sorting
    var usedSlowFilters = slowFilters.filter(el => JSON.stringify(result).includes(el))

    if (usedSlowFilters.length > 0) {
      const newSortingToExclude = slowFilters.filter(el => !usedSlowFilters.includes(el))
      currentSorting = sorting.filter(el => !newSortingToExclude.includes(el.column))
      setSortingsToExclude(newSortingToExclude)
    } else {
      currentSorting = sorting.filter(el => !slowFilters.includes(el.column))
      setSortingsToExclude(slowFilters)
    }
    setSorting(currentSorting)

    if (result) {
      setShowAll(false)
      setFiltersToApi(result)
      props.onConditions({sorting: currentSorting, conditions: result, total_entries: perPreview})
    } else {
      if (!Array.isArray(filtersToApi)) {
        setShowAll(true)
        setFiltersToApi([])
        props.onConditions({sorting: currentSorting, perPage: props.perPage || perPage})
      }
    }
  }

  const updateDate = (filter) => {
    const datesVariants = {
      today: moment(),
      tomorrow: moment().subtract(-1,'days'),
      one_week_ago: moment().subtract(7,'days'),
      one_week_from_now: moment().subtract(-7,'days'),
      one_month_ago: moment().subtract(1,'months'),
      one_month_from_now: moment().subtract(-1,'months')
    }

    var result = {...filter}

    if (Object.keys(datesVariants).includes(filter.conditionChild)) result.value = datesVariants[filter.conditionChild]
    if ('number_of_days_ago' == result.conditionChild) result.value = moment().subtract(result.value,'days')
    if ('number_of_days_from_now' == result.conditionChild) result.value = moment().subtract(-result.value,'days')

    result.value = moment(result.value).tz('America/New_York').format('MM/DD/YYYY')

    return result
  }

  const clearUncompleted = (filtersList) => {
    var result = []
    filtersList.forEach((filter) => {
      if (filter.group) {
        var tempGroup = clearUncompleted(filter.items)
        if (tempGroup.length != 0) result.push({group: true, type: filter.type, items: tempGroup})
      }
      else if (filter.value !== '' && filter.value.length != 0 || filter.condition.includes('empty')) result.push(filter)
    })
    return result
  }

  const processFilters = (filtersList, result) => {
    var items = [...filtersList]
      .map((el) => ['dates_joined', 'dates_played', 'cancelled_games', 'date_of_birth'].includes(el.column) ? updateDate(el) : el)

    var firstItem = items.shift()
    var orItems = items.filter((el) => el.type == 'or' )
    var andItems = items.filter((el) => el.type == 'and' )

    if (orItems.length > 0) {
      firstItem.type = 'or'
      orItems.push(firstItem)
    } else {
      firstItem.type = 'and'
      andItems.push(firstItem)
    }

    orItems.forEach((filter) => {
      if (filter.group) {
        result.push({type: 'or', items: []})
        processFilters(filter.items, result[result.length-1].items, 'or')
      } else result.push({type: filter.condition, column: filter.column, value: filter.value})
    })

    if (andItems.length > 0) {
      result.push({type: 'and', items: []})
      andItems.forEach((filter) => {
        if (filter.group) {
          result[result.length-1].items.push({type: 'or', items: []})
          processFilters(filter.items, result[result.length-1].items[result[result.length-1].items.length-1].items, 'or')
        } else result[result.length-1].items.push({type: filter.condition, column: filter.column, value: filter.value})
      })
    }
  }

  const onView = (viewId) => {
    setShowAll(false)
    setSearchValue('')
    var currentView = props.views.filter( e => e.id == viewId )[0]
    props.setCurrentView(currentView)
    setShowViews(false)
    setFilters(currentView.filters)

    const result = prepareFilters(currentView.filters)
    if (result) setFiltersToApi(result)
    else setSortingsToExclude(slowFilters)

    var currentSorting = currentView.sortings
    var usedSlowFilters = slowFilters.filter(el => JSON.stringify(result).includes(el))

    if (usedSlowFilters.length > 0) {
      const newSortingToExclude = slowFilters.filter(el => !usedSlowFilters.includes(el))
      currentSorting = currentView.sortings.filter(el => !newSortingToExclude.includes(el.column))
      setSortingsToExclude(newSortingToExclude)
    } else {
      currentSorting = currentView.sortings.filter(el => !slowFilters.includes(el.column))
      setSortingsToExclude(slowFilters)
    }

    setSorting(currentSorting)

    if (currentSorting.length > 0 || result)
      props.onConditions({sorting: currentSorting, conditions: result, total_entries: result ? perPreview : null})
  }

  const onUpdateView = (viewId, title) => {
    var currentViewId = viewId ? props.views.filter( e => e.id == viewId )[0].id : null

    props.onUpdateView({id: currentViewId, data: {title: title, sorting: sorting, filters: filters}})
  }

  const onDeleteView = (viewId) => {
    props.onDeleteView({id: viewId})
  }

  const onEditView = (viewId, title) => {
    props.onEditView({id: viewId, title: title})
  }

  const onChangeSearch = value => {
    setSearchValue(value)

    clearTimeout(timer.current)
    timer.current = setTimeout(()=> handleSearch(value), 500)
  }

  return (
    <div className='wrapper'>
      { props.isLoading && <div className='animated-spinner'></div> }
      { showSorting &&
        <SortingForm
          initialSorting={sorting}
          sortingsToExclude={sortingsToExclude}
          onClose={() => setShowSorting(false)}
          onSubmit={(e) => onSortList(e)}
        />
      }
      { showFiltering &&
        <FilterForm
          filters={[...filters]}
          regionsAndLocations={{region: props.regions, facility: props.locations}}
          onClose={() => setShowFiltering(false)}
          onSubmit={(e) => onFilter(e)}
        />
      }
      { showViews &&
        <Modal container={document.body} show={true} onHide={() => setShowViews(false)}  className='views-modal'>
          <Modal.Header closeButton>
            <Modal.Title>Views</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            { alert && <FlashAlert text={alert.text} type={alert.type} onHide={props.clearAlert} /> }
          <Views
            views={props.views}
            selected={props.currentView}
            changesExist={sorting.length > 0 || filters.length > 0}
            onClose={() => setShowViews(false)}
            onSubmit={(e) => onView(e)}
            onProcess={(e, title) => onUpdateView(e, title)}
            onDelete={(e) => onDeleteView(e)}
            onEdit={(e, title) => onEditView(e, title)}
            initialAlert={props.alert}
          />
          </Modal.Body>
        </Modal>
      }
      <div className='players-container'>
        <ActionsRow
          currentView={props.currentView}
          filters={filters}
          sorting={sorting}
          showAll={showAll}
          players={props.players}
          perPreview={perPreview}
          searchValue={searchValue}
          onChangeSearch={onChangeSearch}
          setShowFiltering={setShowFiltering}
          setShowSorting={setShowSorting}
          onSetShowAll={onSetShowAll}
          onImportCredits={props.onImportCredits}
          setShowViewsOn={setShowViewsOn}
          copyPhonesToClipboard={copyPhonesToClipboard}
        />
        { props.totalCount > 0 && (showAll || filters.length == 0) &&
          <PlayersPagination
            page={props.page}
            totalCount={props.totalCount}
            onPageChange={onPageChange}
            onPerPageChange={onPerPageChange}
            perPage={props.perPage || perPage}
          />
        }
        <div className='row player-portal__table'>
          <div className='col-lg-12 player-portal__container'>
            <table>
              <thead>
              <tr>
                <th onClick={() => onSort('name')}>FIRST NAME</th>
                <th onClick={() => onSort('name')}>LAST NAME</th>
                <th onClick={() => onSort('phone')}>PHONE</th>
                <th onClick={() => onSort('gender')}>GENDER</th>
                <th onClick={() => onSort('date_joined')}>DATE JOINED</th>
                <th onClick={() => onSort('region')}>REGION</th>
                { showTimesPlayed &&
                  <th onClick={() => onSort('times_played')}>TIMES PLAYED</th>
                }
                <th onClick={() => onSort('banned')}>BANNED</th>
                <th onClick={() => onSort('opted_out')}>OPTED OUT</th>
              </tr>
              </thead>
              <tbody>
              { props.players && (showAll ? props.players : props.players.slice(0, perPreview - 1)).map((player, index) =>
                <PlayerRow
                  key={index}
                  player={player}
                  showTimesPlayed = {showTimesPlayed}
                  onClick={() => setShowPlayer(player.id)}/>
              )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      { showPlayer &&
        <PlayerModal
          playerId={showPlayer}
          onClose={() => handleModalClose()}
          onUpdate={onUpdate}
          onDelete={onDelete}
        />
      }
    </div>
  )
}

export default Players
